export const FLAG_ROAD_BOOKING_SEARCH_LOADING = 'FLAG_ROAD_BOOKING_SEARCH_LOADING';
export const SET_ROAD_BOOKING_SEARCH_RESULTS = 'SET_ROAD_BOOKING_SEARCH_RESULTS';
export const SET_ROAD_BOOKING_ITINERARY_ID = 'SET_ROAD_BOOKING_ITINERARY_ID';
export const SET_ROAD_BOOKING_SOURCE_CITY_ORIGIN = 'SET_ROAD_BOOKING_SOURCE_CITY_ORIGIN';
export const CHANGE_STEP_ROAD_BOOKING = 'CHANGE_STEP_ROAD_BOOKING';

export const SET_ROAD_BOOKING_STOPS_LOCATION = 'SET_ROAD_BOOKING_STOPS_LOCATION';
export const CLEAR_ROAD_BOOKING_STOPS_LOCATION = 'CLEAR_ROAD_BOOKING_STOPS_LOCATION';
export const FLAG_ROAD_BOOKING_ACTIVITY = 'FLAG_ROAD_BOOKING_ACTIVITY';

export const SET_ROAD_BOOKING_ITINERARY = 'SET_ROAD_BOOKING_ITINERARY';
export const CLEAR_ROAD_BOOKING_ITINERARY = 'CLEAR_ROAD_BOOKING_ITINERARY';

export const SET_ROAD_BOOKING_DISCOUNT = 'SET_ROAD_BOOKING_DISCOUNT';
export const CLEAR_ROAD_BOOKING_DISCOUNT = 'CLEAR_ROAD_BOOKING_DISCOUNT';

export const SET_ROAD_BOOKING_SOLD_SEATS = 'SET_ROAD_BOOKING_SOLD_SEATS';
export const CLEAR_ROAD_BOOKING_SOLD_SEATS = 'CLEAR_ROAD_BOOKING_SOLD_SEATS';
export const ADD_ROAD_BOOKING_SOLD_SEAT = 'ADD_ROAD_BOOKING_SOLD_SEAT';